import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import Config from '../../../../../Config';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';
import {connect} from 'react-redux';

const NavItem = ({props, item, index, buttonType}) => {
  const {
    headerData: {showTabItems, arrowIndex},
    context,
    toggleVisibility,
  } = props;

  const buttonValue = item[buttonType]?.value;
  const buttonExpandedValue = item[buttonType]?.expandedValue;

  const navigateFromNav = (isAllowed, url, mobileIndex) => {
    if (isAllowed == null && url != null) {
      toggleVisibility(true);
      prepareSameWindowUrlWithNavigateTo(url, context);
      props.setIndex(mobileIndex);
    }
  };

  const navigateFromInnerNav = (url) => {
    if (url != null) {
      props.toggleTabButton(index);
      toggleVisibility(true);
      prepareSameWindowUrlWithNavigateTo(url, context);
    }
  };

  const handleOnClick = () => {
    if (buttonValue != null) {
      props.toggleTabButton(index);
    } else {
      toggleVisibility(true);
      prepareSameWindowUrlWithNavigateTo(item?.link?.value, context);
    }
  };

  return (
    <div key={index} onClick={() => navigateFromNav(buttonValue, item?.link?.value, index)}>
      <div className={`${buttonValue != null ? 'with-arrow' : ''} nav-item`} onClick={() => handleOnClick()}>
        <div className={`${showTabItems && arrowIndex === index ? 'isSelected' : ''} style-nav-item`}>
          {item?.icon?.value != null && <Image style={{marginLeft: '5px'}} src={Config.epiBaseUrl + item?.icon?.expandedValue?.url} />}
          <div className={`${index === index ? 'isSelectedColor' : ''} text-color`}>{item?.text?.value}</div>
        </div>
        <div className='arrow-location'>
          {buttonValue != null && (
            <Image className={`${showTabItems === true && arrowIndex === index ? 'up' : 'down'}`}
              style={{marginRight: '3px'}}
              src={require('../../images/down-mobile.svg')} />
          )}
        </div>
      </div>
      {buttonValue != null && showTabItems && arrowIndex === index && (
        <div className='nav-item-list-wrapper'>
          {buttonExpandedValue.map((val, i) => (
            <div className='wrapper-item'>
              {val.links?.expandedValue.map((v, ind) => (
                <span key={ind} onClick={() => navigateFromInnerNav(v?.link?.value)} className='wrapper-item-design'>
                  {v.text?.value}
                </span>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    headerData: state.Header,
    authentication: state.authentication,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NavItem);
